export default __webpack_public_path__ + "media/zurb/img/icons/favicon/favicon-16x16-8213d9ef31710213b65e2183840e2271.png";